import React from "react";
import { IconButton } from "@mui/material";
import EditableTextCell from "./EditableTextCell";

import styles from "../../../v2Styles.module.css";
import "./PreviewSwmsStyle.css";

export default function ActivityHeaderRow({ actIndex, activityNumber, activityName, onUpdate, onDelete, handleRef, onAdd, isDisabled }) {
  return (
    <tr className="preview-swms-activity-header-row">
      <td className="font-weight-bold" style={{ position: "relative", backgroundColor: "#96c6e7", cursor: "move" }}>
        <span>{activityNumber}</span>
        {!isDisabled ? (
          <div className="position-absolute" style={{ top: "5px", right: "2px" }}>
            <IconButton ref={handleRef} onClick={(e) => { e.stopPropagation(); e.preventDefault(); }} className={`${styles.IconBtn} ${styles.SecondaryColor} p-0 activity-drag-icon`} style={{ height: "auto", backgroundColor: "#96c6e7" }}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" style={{ height: "16px", width: "16px" }}>
                <path fill="currentColor" d="M288 104C288 81.9 270.1 64 248 64L200 64C177.9 64 160 81.9 160 104L160 152C160 174.1 177.9 192 200 192L248 192C270.1 192 288 174.1 288 152L288 104zM288 296C288 273.9 270.1 256 248 256L200 256C177.9 256 160 273.9 160 296L160 344C160 366.1 177.9 384 200 384L248 384C270.1 384 288 366.1 288 344L288 296zM160 488L160 536C160 558.1 177.9 576 200 576L248 576C270.1 576 288 558.1 288 536L288 488C288 465.9 270.1 448 248 448L200 448C177.9 448 160 465.9 160 488zM480 104C480 81.9 462.1 64 440 64L392 64C369.9 64 352 81.9 352 104L352 152C352 174.1 369.9 192 392 192L440 192C462.1 192 480 174.1 480 152L480 104zM352 296L352 344C352 366.1 369.9 384 392 384L440 384C462.1 384 480 366.1 480 344L480 296C480 273.9 462.1 256 440 256L392 256C369.9 256 352 273.9 352 296zM480 488C480 465.9 462.1 448 440 448L392 448C369.9 448 352 465.9 352 488L352 536C352 558.1 369.9 576 392 576L440 576C462.1 576 480 558.1 480 536L480 488z" />
              </svg>
            </IconButton>
          </div>
        ) : null}
      </td>
      <EditableTextCell
        isDisabled={isDisabled}
        onUpdate={onUpdate}
        showDeleteIcon={true}
        onDelete={() => onDelete({ type: "activity", actIndex })}
        dataObj={{ actIndex, key: "activity_name" }}
        cellBackground="#96c6e7"
        visibleBackground="#96c6e7bf"
        cellStyle={{ fontWeight: "bold" }}
        textAreaStyle={{ fontWeight: "bold" }}
        colSpan={7}
        showAddIcon={true}
        onAdd={() => onAdd({ type: "action", actIndex })}
        value={activityName || ""}
      />
    </tr>
  );
}
